import { useContextSelector } from 'use-context-selector';

import { EditorContext } from '../contexts';
import { DocumentComponent, DocumentNode } from '../types';
import { findNode } from '../utils/node';

export interface EditorNodeDataProps {
  node: DocumentNode;
  component: DocumentComponent;
}

export function useEditorNodeData(
  path: number[] = [],
): EditorNodeDataProps {
  const node = useContextSelector(
    EditorContext,
    (context) => (context != null
      ? findNode(context.state.document, path)
      : null),
  );
  if (node == null) { throw new Error('The path cannot be found'); }
  const component = useContextSelector(
    EditorContext,
    (context) => context?.components[node.type],
  );
  if (component == null) { throw new Error('The component cannot be found'); }
  return { node, component };
}


